__turbopack_context__.v({
  "divider": "TeamMembersEditMember-module-scss-module__gh_xwa__divider",
  "field": "TeamMembersEditMember-module-scss-module__gh_xwa__field",
  "fieldLabel": "TeamMembersEditMember-module-scss-module__gh_xwa__fieldLabel",
  "memberInput": "TeamMembersEditMember-module-scss-module__gh_xwa__memberInput",
  "memberInputAvatar": "TeamMembersEditMember-module-scss-module__gh_xwa__memberInputAvatar",
  "memberInputName": "TeamMembersEditMember-module-scss-module__gh_xwa__memberInputName",
  "removeButton": "TeamMembersEditMember-module-scss-module__gh_xwa__removeButton",
  "section": "TeamMembersEditMember-module-scss-module__gh_xwa__section",
  "skills": "TeamMembersEditMember-module-scss-module__gh_xwa__skills",
  "toggleLabel": "TeamMembersEditMember-module-scss-module__gh_xwa__toggleLabel",
  "toggleRow": "TeamMembersEditMember-module-scss-module__gh_xwa__toggleRow",
});
